// @flow

import { Component } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import type { UIProviderContext } from './UIProvider';
import { UIContextPropType } from './UIProvider';
import TickIcon from '../../assets/tick.svg';

type Props = {
  id: string,
  value: boolean,
  onChange: (newValue: boolean) => void,
  children?: React.Node,
  disabled?: boolean,
  tabIndex?: number,
};

const CheckboxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const Tick = styled.img`
  position: absolute;
  top: 0.1875rem;
  right: 0.125rem;
  width: 0.875rem;
  height: 0.75rem;
  object-fit: contain;
  object-position: 50% 50%;
`;

const StyledCheckbox = styled.input`
  visibility: hidden;
`;

const StyledLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  width: 1.5rem;
`;

const StyledLabel = styled.label`
  position: relative;
  max-width: 1.25rem;
  height: 1.25rem;
  width: 1.25rem;
  cursor: pointer;
  border: 1px solid;
  border-radius: 0.125rem;
  flex: 1;
  flex-basis: auto; //IE fix
  background-color: ${(props) =>
    props.disabled
      ? props.theme.disabledColor
      : props.value
      ? props.theme.actionColor
      : props.theme.backgroundColor};
  border-color: ${(props) =>
    props.disabled ? props.theme.disabledColor : props.theme.actionColor};
`;

const Label = styled.label`
  flex: 1;
  margin-left: 0.688rem;
`;

class Checkbox extends Component<Props> {
  context: UIProviderContext;

  static contextTypes = {
    dbui: UIContextPropType,
  };

  handleChange = (evt: SyntheticInputEvent<HTMLInputElement>) => {
    this.props.onChange(evt.target.checked);
    this.context.dbui.registerAnalyticsEvent(this.props.id);
  };

  render() {
    return (
      <CheckboxWrapper
        role="checkbox"
        aria-checked={this.props.value}
        tabIndex={this.props.tabIndex || 0}
      >
        <StyledLabelContainer>
          <StyledLabel value={this.props.value} disabled={this.props.disabled}>
            <StyledCheckbox
              id={this.props.id}
              type="checkbox"
              checked={this.props.value}
              onChange={this.handleChange}
              disabled={this.props.disabled}
            />
            {this.props.value === true ? <Tick src={TickIcon} /> : null}
          </StyledLabel>
        </StyledLabelContainer>
        <Label htmlFor={this.props.id}>{this.props.children}</Label>
      </CheckboxWrapper>
    );
  }
}

export default Checkbox;
